//Issuer Family

let IssuerFamilyActions = Reflux.createActions([
    'fetchIssuerFamily'
]);

class IssuerFamilyStore extends Reflux.Store {
    constructor() {
        super();
        this.state = {
            family: {}
        };
        this.listenables = IssuerFamilyActions;
    }

    onFetchIssuerFamily(orgid) {
        let _self = this;
        httpGet(buildRoute(mantlroutes.org_family,{ orgid: orgid })).then(
            function(value) {
                var response = JSON.parse(value);
                // console.log(response);
                _self.setState({ family: response });
            })
        .catch(
            function(reason) {
                alertify.error('Unable to Retrieve Family')
            });
    }

}


class IssuerFamilyManager {
    constructor(options) {
        this.defaults = {
            orgid: null
        }
        this.settings = extend( {}, this.defaults, options );
        this.Actions = IssuerFamilyActions;
        this.render();
        this.initStore();
    }

    render() {
        let target = this.settings.target;
        ReactDOM.render(<IssuerFamilyWrapper settings={this.settings} />, document.getElementById(target));
    }

    initStore() {
        this.Actions.fetchIssuerFamily(this.settings.orgid);
    }

}

//Reflux.Component extends React.Component
class IssuerFamilyWrapper extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = new IssuerFamilyStore(); // <- just assign the store class itself
        this.getChildren = this.getChildren.bind(this);
    }

    getChildren() {
        let children = [];
        this.state.family.children.forEach((element,index) => {
            children.push( <IssuerFamilyChild key={"key_"+element.id} settings={this.props.settings} issuer={element} /> );
        });
        return children;
    }

    render() {
        if(this.state.family.parent != undefined){
            let children = this.getChildren();
            return (
                <section className="family">
                    <IssuerFamilyParent settings={this.props.settings} issuer={this.state.family.parent}></IssuerFamilyParent>
                    <ul className="organization-children">{children}</ul>
                </section>
            );
        }

        return (
            <LoadingSpinner></LoadingSpinner>
        );
    }
}

class IssuerFamilyParent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let has_logo = this.props.issuer.image != null;
        return (
            <div className="card card--rounded card--tight text--left card--organization-parent">
                <div className="card-content">
                    <a href={buildView(mantlroutes.org_about_view,{ orgid: this.props.issuer.id })} className="organization-parent">
                        {has_logo && (
                            <img src={this.props.issuer.image} alt={"Logo for " + this.props.issuer.name} />
                        )}

                        {!has_logo && this.props.issuer.academic && (
                            <img src={mantl.static_url + 'assets/images/icon-org-academic.svg' } alt="Academic Org Icon" />
                        )}
                        {!has_logo && !this.props.issuer.academic && (
                            <img src={mantl.static_url + 'assets/images/icon-org-commercial.svg' } alt="Commercial Org Icon" />
                        )}
                        {this.props.issuer.name}</a>
                    <p className="organization-byline"><i className="icon-cloud icon--primary emspace"></i> <a href={this.props.issuer.website} target="_blank">{this.props.issuer.website}</a>
                    <br />Registered <FormattedDate date={this.props.issuer.created}></FormattedDate></p>
                </div>
            </div>
        )
    }
}

class IssuerFamilyChild extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
    }

    render() {
        let has_logo = this.props.issuer.image != null;
        return (
            <li>
                <div className="card card--rounded card--tight text--left">
                    <div className="card-content">
                        <a href={buildView(mantlroutes.org_about_view,{ orgid: this.props.issuer.id })} className="organization-parent text--primary">
                        {has_logo && (
                            <img src={this.props.issuer.image} alt={"Logo for " + this.props.issuer.name} />
                        )}

                        {!has_logo && this.props.issuer.academic && (
                            <img src={mantl.static_url + 'assets/images/icon-org-academic.svg' } alt="Academic Org Icon" />
                        )}
                        {!has_logo && !this.props.issuer.academic && (
                            <img src={mantl.static_url + 'assets/images/icon-org-commercial.svg' } alt="Commercial Org Icon" />
                        )}
                        {this.props.issuer.name}</a>
                        <p className="organization-byline"><i className="icon-cloud icon--primary emspace"></i> <a href={this.props.issuer.website} target="_blank">{this.props.issuer.website}</a>
                        <br />Registered <FormattedDate date={this.props.issuer.created}></FormattedDate></p>
                    </div>
                </div>
            </li>
        )
    }
}
